<template>
  <ValidationProvider v-slot="{ errors }" :vid="$attrs.vid" :name="$attrs.label" :rules="rules">
    <v-autocomplete
      v-bind="$attrs"
      :items="filteredItems"
      :item-text="itemTextFn"
      item-value="uniqueKey"
      :return-object="true"
      multiple
      chips
      deletable-chips
      :value="value"
      :error-messages="errorMessages && errorMessages.length ? errorMessages : errors"
      :loading="loading"
      :search-input="searchInput"
      v-on="$listeners"
      @input="$emit('input', $event)"
      @update:search-input="val => searchInput = val"
    >
      <template #selection="{ item, index }">
        <v-chip v-if="index < 4">
          <span>{{ getName(item) }}</span>
        </v-chip>
        <span v-if="index === 4 && value && value.length > 4" class="grey--text text-caption">
          (+{{ value.length - 4 }} others)
        </span>
      </template>
      <template #item="{ item }">
        <v-list-item-action>
          <v-checkbox
            :input-value="value && value.some(selected => selected.uniqueKey === item.uniqueKey)"
            color="primary"
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.exercise && item.exercise.name ? item.exercise.name : '' }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <slot />
    </v-autocomplete>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'VeeAssessmentAutocomplete',
  components: { ValidationProvider },
  props: {
    rules: {
      type: [String, Object],
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      searchInput: '',
    }
  },
  computed: {
    filteredItems() {
      if (!this.items || this.items.length === 0) {
        return []
      }
      const search = (this.searchInput || '').toLowerCase()
      if (!search) {
        return this.sortedItems
      }
      const filtered = this.sortedItems.filter(item => {
        const exerciseName = (item.exercise && item.exercise.name ? item.exercise.name : '').toLowerCase()
        const match = exerciseName.includes(search)

        return match
      })

      return filtered
    },
    sortedItems() {
      if (!this.items || this.items.length === 0) {
        return []
      }
      if (!this.value || this.value.length === 0) {
        return this.items
      }
      const selectedKeys = new Set(this.value.map(item => item.uniqueKey))
      const sorted = [...this.items].sort((a, b) => {
        const aIsSelected = selectedKeys.has(a.uniqueKey)
        const bIsSelected = selectedKeys.has(b.uniqueKey)
        if (aIsSelected && !bIsSelected) {
          return -1
        }
        if (!aIsSelected && bIsSelected) {
          return 1
        }

        return 0
      })

      return sorted
    },
  },

  /*
  watch: { //WATCH DO DEBUG
    items: {
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.length === 0) return;
        console.log('[DEBUG AUTOCOMPLETE] Received items list. Size:', newVal.length);
        console.log('[DEBUG AUTOCOMPLETE] The first item:', this.getName(newVal[0]));
      }
    },
    value: {
      immediate: true,
      handler(newVal) {
        console.log('[DEBUG AUTOCOMPLETE] Received value (v-model):', newVal);
      }
    }
  }, */
  methods: {
    getName(item) {
      if (!item) return ''
      if (item.exercise && item.exercise.name) return item.exercise.name
      if (item.name) return item.name

      return ''
    },
    itemTextFn(item) {
      return this.getName(item)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-list-item--highlighted::before {
  opacity: 0 !important;
}
</style>
